import React, { useEffect, useState, useContext } from 'react';
import { useHistory } from "react-router-dom";
import { toast } from "react-toastify";
import toastError from "../../errors/toastError";
import api from "../../services/api";

import Avatar from "@material-ui/core/Avatar";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";

import { AuthContext } from "../../context/Auth/AuthContext";
import { SettingsContext } from "../../context/Settings/SettingsContext";
import {
    canOpenTicket,
    noAccessMessage,
    pooledModeFromSetting,
} from "../../helpers/canOpenTicket";

import { Button, Divider, } from "@material-ui/core";

const VcardPreview = ({ contact, numbers }) => {
    const history = useHistory();
    const { user, realUser } = useContext(AuthContext);
    const { getSetting } = useContext(SettingsContext);

    const [selectedContact, setContact] = useState({
        name: "",
        number: 0,
        profilePicUrl: ""
    });

    useEffect(() => {
        const delayDebounceFn = setTimeout(() => {
            const fetchContacts = async () => {
                try {
                    let contactObj = {
                        name: contact,
                        // number: numbers.replace(/\D/g, ""),
                        number: numbers !== undefined && numbers.replace(/\D/g, ""),
                        email: ""
                    }
                    const { data } = await api.post("/contact", contactObj);
                    setContact(data)

                } catch (err) {
                    toastError(err);
                }
            };
            fetchContacts();
        }, 500);
        return () => clearTimeout(delayDebounceFn);
    }, [contact, numbers]);

    const handleNewChat = async () => {
        try {
            // Reusar la conversación previa si aplica (respeta ticketReopenWindowDays).
            // El backend (CreateTicketService) también lo aplica; este pre-check evita
            // el POST cuando ya hay un hilo al que volver.
            if (selectedContact.id) {
                const { data: active } = await api.get(
                    `/contacts/${selectedContact.id}/active-ticket`
                );
                if (active?.exists) {
                    // feat_337 — mismo guard que "+ NUEVO" y Contactos: decidir
                    // antes de navegar en vez de comerse el 404 de ShowTicketService.
                    const verdict = canOpenTicket(active, user, {
                        pooledMode: pooledModeFromSetting(
                            getSetting("closedTicketsPooledByQueue")
                        ),
                    });
                    if (verdict.ok) {
                        history.push(`/tickets/${active.ticketId}`);
                    } else {
                        toast.warn(noAccessMessage(verdict), { autoClose: 10000 });
                    }
                    return;
                }
            }
            const { data: ticket } = await api.post("/tickets", {
                contactId: selectedContact.id,
                // feat_299: autoría siempre del admin real (ver NewTicketModal).
                userId: realUser?.id ?? user.id,
                status: "open",
            });
            history.push(`/tickets/${ticket.id}`);
        } catch (err) {
            toastError(err);
        }
    }

    return (
        <>
            <div style={{
                minWidth: "250px",
            }}>
                <Grid container spacing={1}>
                    <Grid item xs={2}>
                        <Avatar src={selectedContact.profilePicUrl} />
                    </Grid>
                    <Grid item xs={9}>
                        <Typography style={{ marginTop: "12px", marginLeft: "10px" }} variant="subtitle1" color="primary" gutterBottom>
                            {selectedContact.name}
                        </Typography>
                    </Grid>
                    <Grid item xs={12}>
                        <Divider />
                        <Button
                            fullWidth
                            color="primary"
                            onClick={handleNewChat}
                            disabled={!selectedContact.number}
                        >Conversar</Button>
                    </Grid>
                </Grid>
            </div>
        </>
    );

};

export default VcardPreview;